// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_2b77a52a"};